import { motion } from "framer-motion";
import {
  FaLaptopCode,
  FaMobileAlt,
  FaCloud,
  FaPalette,
  FaBullhorn,
  FaChartLine,
} from "react-icons/fa";
import heroImage from "../assets/hero1.jpeg";
import "./Home.css";

export default function Home() {
  const services = [
    {
      title: "Web Development",
      desc: "Modern, scalable web applications.",
      icon: <FaLaptopCode />,
    },
    {
      title: "Mobile Apps",
      desc: "High-performance Android & iOS apps.",
      icon: <FaMobileAlt />,
    },
    {
      title: "Cloud Solutions",
      desc: "Secure & scalable cloud systems.",
      icon: <FaCloud />,
    },
    {
      title: "UI/UX Design",
      desc: "Human-centered product design.",
      icon: <FaPalette />,
    },
    {
      title: "Digital Marketing",
      desc: "Data-driven growth strategies.",
      icon: <FaBullhorn />,
    },
    {
      title: "IT Consulting",
      desc: "Expert guidance for business growth.",
      icon: <FaChartLine />,
    },
  ];

  const stats = [
    { value: "10+", label: "Clients Served" },
    { value: "20+", label: "Team Members" },
    { value: "30+", label: "Services Offered" },
  ];

  const testimonials = [
    {
      name: "Nazeeb",
      role: "Startup Founder",
      text: "WeMindSolutions delivered an excellent product on time. Highly professional team.",
      image: "https://i.pravatar.cc/150?img=11",
    },
    {
      name: "Vanitha Sharma",
      role: "Startup Founder",
      text: "Their UI/UX and development quality exceeded our expectations.",
      image: "https://i.pravatar.cc/150?img=5",
    },
    {
      name: "Bhavana",
      role: "Product Manager",
      text: "Reliable, scalable, and future-ready solutions. Strongly recommended.",
      image: "https://i.pravatar.cc/150?img=31",
    },
  ];

  return (
    <div className="home">

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="hero-content"
          >
            <h1>WeMindSolutions Pvt. Ltd.</h1>
            <p className="tagline">Where Your Dreams Take Shape</p>
            <p className="hero-text">
              Innovative IT solutions transforming ideas into powerful digital experiences.
            </p>
            <a href="./contact" className="hero-btn">
              Get Started
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="hero-image"
          >
            <img src={heroImage} alt="Hero" />
          </motion.div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="stats">
        <div className="stats-container">
          {stats.map((stat, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.2 }}
              className="stat-card"
            >
              <motion.h2
                initial={{ scale: 0.8 }}
                whileInView={{ scale: 1 }}
                transition={{ type: "spring", stiffness: 120 }}
              >
                {stat.value}
              </motion.h2>
              <p>{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="services-container">
          <h2 className="section-title">Our Services</h2>

          <div className="services-grid">
            {services.map((service, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.15 }}
                className="service-card"
              >
                <div className="service-icon-wrapper">
                  {service.icon}
                </div>
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <div className="testimonials-container">
          <h2 className="section-title">What Our Clients Say</h2>

          <div className="testimonials-grid">
            {testimonials.map((t, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.2 }}
                className="testimonial-card"
              >
                <img src={t.image} alt={t.name} />
                <p className="testimonial-text">“{t.text}”</p>
                <h4>{t.name}</h4>
                <span>{t.role}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
